import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { formatDateTimeWithLocalTimezone } from '../map/observer-map.helpers';
import { ObserverPositionDto } from '../models/observer-position-dto';

@Injectable({
  providedIn: 'root',
})
export class ObserverApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl.replace(/\/$/, '')}/api/observer`;
  private readonly lookbackSeconds = 4;

  getObservers(dateTime = new Date()): Observable<ObserverPositionDto | ObserverPositionDto[]> {
    const formattedDateTime = encodeURIComponent(formatDateTimeWithLocalTimezone(dateTime));
    const url = `${this.baseUrl}?datetime=${formattedDateTime}&lookbackSeconds=${this.lookbackSeconds}`;

    return this.http.get<ObserverPositionDto | ObserverPositionDto[]>(url);
  }
}
